import React, { useState} from 'react';
import axios from 'axios';
import { Alert } from 'react-bootstrap';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import IBAN from 'iban';
import { Form } from 'react-bootstrap';

function ConfigurerCotisation(props) {
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [confirmation,setConfirmation] = useState(false);
  const Navigate = useNavigate();
  const [numeroCompte, setNumeroCompte] = useState("");
  const [numeroValide, setNumeroValide] = useState(true)
  const [commentaire, setCommentaire] = useState(""); 
  const [coûts, setCoûts] = useState(""); 
  const [dateMax, setDateMax] = useState(""); 
  const [lienRevolut, setLienRevolut] = useState(""); 
  const apiUrl = process.env.REACT_APP_API_URL;


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (!coûts || !dateMax || !numeroCompte ) {
        setError("Veuillez remplir tous les champs du formulaire.");
        setIsLoading(false);
        return;
      }
      if (numeroValide === false){
        setError("Numéro de compte bancaire invalide.");
        setIsLoading(false);
        return;
      }
    try {
      await axios.post(`${apiUrl}/cotisation/configurer`, {
        idEquipe : props.userData.user.donnée.results[0].id_equipe,
        coûts : coûts,
        dateMax : dateMax,
        numeroCompte : numeroCompte,
        lienRevolut : lienRevolut,
        commentaire : commentaire


      }, {
        withCredentials: true
      });

      setError(null);
      setIsLoading(false);
      window.location.reload(); 

    } catch (error) {
      if (error.response) {
        setIsLoading(false)
        setError(error.response.data.message);
      } else {
        setIsLoading(false)
        setError(true);
      }
    }
  };




  const handleChangeNumeroCompte = (event) => {
    const numero = event.target.value;
    setNumeroCompte(numero);

    if (numero === '') {
        setNumeroValide(true); 
    } else {
        const valide = IBAN.isValid(numero); 
        setNumeroValide(valide);
    }
};


  if (isLoading) {
    return (
    <div className="centered-content">
      <img src="/img/logo.png" alt="Logo" className="centered-logo" />
      <br/>
      <span className="loader"></span>
    </div>
    
    );  
  }

return (
  <>
    {props.userData && (
        <>
            {confirmation ? (
                <Modal show={confirmation} onHide={() => setConfirmation(false)}>
                    <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Voulez-vous vraiment les mettre en place ? 
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary"  onClick={() => setConfirmation(false)} >
                        Annuler
                    </Button>
                    <Button variant="primary" onClick={(e) => {handleSubmit(e);setConfirmation(false)}} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>
                     Confirmer
                    </Button>
                    </Modal.Footer>
                </Modal>

            ):(
            <Modal show={props.userData} onHide={() => Navigate('/coach/accueil')}>
                <Modal.Header closeButton>
                <Modal.Title>Configurer les cotisations</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                {error && <Alert variant="danger">{error}</Alert>}
                    <p>Les cotisations pour votre équipe ne sont pas configurées. Vous pouvez les configurer ci-dessous :</p>
                    <div className="mb-3">
                        <label htmlFor="cout">Coût :</label>
                        <span className="ms-2">€</span>
                        <input type="number" className="form-control" id="cout"  value={coûts} onChange={(e)=>setCoûts(e.target.value)}/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="dateMax">Date maximale de paiement :</label>
                        <input type="date" className="form-control" id="dateMax" value={dateMax} onChange={(e)=>setDateMax(e.target.value)} />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="dateMax">Commentaire pour les joueurs (facultatif): </label>
                        <Form.Control as="textarea" placeholder="Ajoutez un commentaire" value={commentaire} onChange={(e)=>setCommentaire(e.target.value)} rows={3} />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="compteBancaire">Compte bancaire :</label>
                        <input type="text" className={`form-control ${!numeroValide ? 'is-invalid' : ''}`} id="compteBancaire" placeholder="BE1234567890" value={numeroCompte} onChange={handleChangeNumeroCompte} />
                        {!numeroValide && <div className="invalid-feedback">Numéro de compte bancaire invalide.</div>}
                        <small className="form-text text-muted">Veuillez entrer le numéro de compte bancaire au format BEXXXXXXXXXX.</small>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="compteRevolut">Lien de partage Revolut (facultatif) :</label>
                        <input type="text" className="form-control" id="compteRevolut" value={lienRevolut} onChange={(e)=>setLienRevolut(e.target.value)} placeholder="Lien Revolut" />
                        <small className="form-text text-muted">Vous pouvez gérer les paiements via Revolut et permettre à vos joueurs de vous envoyer leur cotisation sur votre compte directement.</small>
                        <br/>
                        <small className="form-text text-muted">
                            Créez un compte Revolut en suivant ce&nbsp;
                            <a href='https://www.revolut.com/fr-BE/business/?pid=Google&af_c_id=20393769072&af_adset_id=150382261414&af_ad=692710877400&af_sub3=ouvrir%20un%20compte%20bancaire&placement=&gclid=Cj0KCQjwmMayBhDuARIsAM9HM8fuN5KkErAZ0JTF-DxWghOo98KkrMJSJ32eTfui9mM4J2A0nk2mFfQaAn_DEALw_wcB&utm_source=Google&c=Rev_BIZ_GSearch_2023_BL_FR_ALL&utm_campaign=Rev_BIZ_GSearch_2023_BL_FR_ALL&promo=B2B_SEARCH_BIZ_BL&af_sub5=BL&gad_source=1' target="_blank" rel="noopener noreferrer">lien</a>.
                        </small>
                        <br/>
                        <small className="form-text text-muted">
                            Ensuite, entrez votre lien de partage Revolut en suivant ce&nbsp;
                            <a href='https://help.revolut.com/fr-BE/help/transfers/outbound-transfers/how-to-send-money-to-another-bank/what-recipient-account-details-do-i-need/what-if-i-don-t-know-the-recipient-s-account-details/' target="_blank" rel="noopener noreferrer">tutoriel</a>.
                        </small>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={() => Navigate('/coach/accueil')} >
                    Annuler
                </Button>
            <Button variant="primary" onClick={() => setConfirmation(true)}  style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>
                    Configurer
                </Button>
                </Modal.Footer>
            </Modal>
            )}
        </>
    )}
    
  </>
);
}

export default ConfigurerCotisation;